import { humanizeMobileAppIds } from 'modules/campaigns/editor/components/Sections/utils';
import { fetchMobileApps } from 'modules/mobileApps/actions';
import { selectMobileApps } from 'modules/mobileApps/selectors';
import { combineSubtextVisibleListWithOverflow } from 'modules/workflowNodeEditors/components/sendNodeEditors/BaseSendEditor/DeliverySection/SelectiveTargeting/utils';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCampaignContext } from '../context';

export const useDestination = (isMediumWithDestination: boolean) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isMediumWithDestination) {
      dispatch(fetchMobileApps());
    }
  }, []);

  const mobileAppsInProject = useSelector(selectMobileApps);

  const { campaign } = useCampaignContext();
  const { mobileAppIds } = campaign;
  const destinationType = humanizeMobileAppIds(mobileAppIds);

  const destinationSelections =
    destinationType === 'Custom' &&
    combineSubtextVisibleListWithOverflow(
      mobileAppsInProject?.filter((app) => mobileAppIds?.find((id) => app.id === id)),
    );

  return { destinationType, destinationSelections };
};
